import HttpClient from './http-client';
import URL from './url';

export default class QuestionSetApi {

    static createQuestionSet(payload) {
        return HttpClient.post(URL.BASE_URL + URL.SCHOOL_ASSESSMENT_QUESTION_SET, null, payload);
    }

    static updateQuestionToQuestionSet(payload) {
        return HttpClient.put(URL.BASE_URL + URL.SCHOOL_ASSESSMENT_QUESTION_SET, null, payload);
    }

    static removeQuestionSet(payload) {
        return HttpClient.delete(URL.BASE_URL + URL.SCHOOL_ASSESSMENT_QUESTION_SET, null, payload);
    }

    static getQuestionSet(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.SCHOOL_ASSESSMENT_QUESTION_SET + "?" + params.join('&') : URL.SCHOOL_ASSESSMENT_QUESTION_SET;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getQuestions(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.SCHOOL_QUESTION_SET_QUESTION + "?" + params.join('&') : URL.SCHOOL_QUESTION_SET_QUESTION;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getPracticeQuestionComplexity(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.PRACTICE_QUESTION_COMPLEXITY + "?" + params.join('&') : URL.PRACTICE_QUESTION_COMPLEXITY;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static updateQuestion(payload) {
        return HttpClient.put(URL.BASE_URL + URL.SCHOOL_QUESTION_SET_QUESTION, null, payload);
    }

    static deleteQuestion(payload) {
        return HttpClient.delete(URL.BASE_URL + URL.SCHOOL_QUESTION_SET_QUESTION, null, payload);
    }

}